import React from "react";
import { format } from "date-fns";
import { Link } from "react-router-dom";

const ShardSales = ({ shards }) => {
  const formatAddress = (address, label) => {
    if (!address) return "Unknown";
    if (address === "0x0000000000000000000000000000000000000000") return "$PIXEL";
    if (label) return label;
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  return (
    <div className="component-style">
      <div className="hidden sm:grid grid-cols-12 gap-2 px-4 py-2 bg-[var(--table-header)] rounded-lg font-medium text-sm">
        <div className="col-span-2">Date</div>
        <div className="col-span-4">Transaction</div>
        <div className="col-span-3">From</div>
        <div className="col-span-3">To</div>
      </div>

      {shards.map((shard) => (
        <div key={shard.transaction_hash} className="sm:grid sm:grid-cols-12 gap-2 px-4 py-3 border-b hover:bg-gray-50 flex flex-col sm:flex-none">
          {/* Date */}
          <div className="col-span-2 text-sm">
            <span className="block sm:hidden font-medium">{format(new Date(shard.block_timestamp), "MMM d, yyyy")}</span>
            <span className="hidden sm:block">{format(new Date(shard.block_timestamp), "MMM d, yyyy")}</span>
          </div>

          {/* Transaction */}
          <div className="col-span-4 text-sm">
            <a
              href={`https://app.roninchain.com/tx/${shard.transaction_hash}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-blue-600 hover:underline"
            >
              <i className="fa-solid fa-arrow-up-right-from-square" />
              {` ${shard.transaction_hash.slice(0, 6)}...${shard.transaction_hash.slice(-4)}`}
            </a>
          </div>

          {/* From */}
          <div className="col-span-3 text-sm">
            {shard.from_address_entity_logo && (
              <img src={shard.from_address_entity_logo} alt={shard.from_address_entity} className="w-4 h-4 inline-block mr-1 rounded-full" />
            )}
            <a href={`https://app.roninchain.com/address/${shard.from_address}`} target="_blank" rel="noreferrer" className="panel-link">
              {formatAddress(shard.from_address, shard.from_address_label)}
            </a>{" "}
            <Link to={`/lookup/players/${shard.from_address}`} target="_blank" rel="noreferrer">
              <i className="fa-solid fa-arrows-to-dot" />
            </Link>
          </div>

          {/* To */}
          <div className="col-span-3 text-sm">
            {shard.to_address_entity_logo && (
              <img src={shard.to_address_entity_logo} alt={shard.to_address_entity} className="w-4 h-4 inline-block mr-1 rounded-full" />
            )}
            <a href={`https://app.roninchain.com/address/${shard.to_address}`} target="_blank" rel="noreferrer" className="panel-link">
              {formatAddress(shard.to_address, shard.to_address_label)}
            </a>{" "}
            <Link to={`/lookup/players/${shard.to_address}`} target="_blank" rel="noreferrer">
              <i className="fa-solid fa-arrows-to-dot" />
            </Link>
          </div>
        </div>
      ))}

      {shards.length === 0 && <div className="text-center py-8 text-gray-500">No shard sales found</div>}
    </div>
  );
};

export default ShardSales;
